
import React from "react";
import ShowMoreText from "react-show-more-text";

const BoardCard = ({ boardDetails }) => {
  return (
    <div className="flex md:justify-start md:items-start flex-col md:flex-row gap-5 my-10 py-2 w-full border-b">
      <div className="flex flex-col justify-center items-center gap-10 md:w-[30%] md:border-r ">
        <div className=" w-[200px] h-[200px] ">
          <img
            src={boardDetails?.imgUrl}
            alt=""
            className=" w-full h-full rounded-[100%] object-fill"
          />
        </div>
        <p className=" capitalize text-[12px] flex flex-col justify-center items-center  w-full text-center ">
          {boardDetails?.title} <span className="text-md font-bold">{boardDetails?.name}</span>
        </p>
      </div>

      <div className="md:w-[70%] ">
        <p className="  text-[14px] text-[grey] ">
        <ShowMoreText
                /* Default options */
                lines={7}
                more="Show more"
                less="Show less"
                className="content-css"
                anchorClass="show-more-less-clickable"
                // onClick={this.executeOnClick}
                expanded={false}
                // width={280}
                truncatedEndingComponent={"... "}
            >

           
          {boardDetails.description}
          </ShowMoreText>
        </p>
      </div>
    </div>
  );
};

export default BoardCard;
